import React from 'react';

const RATINGS = [
  { value: 0, label: 'Blackout', sublabel: 'No idea', gradient: 'from-red-700 to-red-600', hoverGradient: 'hover:from-red-600 hover:to-red-500', glow: 'rgba(231,76,60,0.3)', key: '1' },
  { value: 1, label: 'Hard', sublabel: 'Recognized it', gradient: 'from-orange-600 to-orange-500', hoverGradient: 'hover:from-orange-500 hover:to-orange-400', glow: 'rgba(243,156,18,0.3)', key: '2' },
  { value: 2, label: 'Good', sublabel: 'Got it with effort', gradient: 'from-blue-600 to-blue-500', hoverGradient: 'hover:from-blue-500 hover:to-blue-400', glow: 'rgba(74,144,217,0.3)', key: '3' },
  { value: 3, label: 'Easy', sublabel: 'Instant recall', gradient: 'from-green-600 to-green-500', hoverGradient: 'hover:from-green-500 hover:to-green-400', glow: 'rgba(46,204,113,0.3)', key: '4' },
];

/**
 * 4-button self-rating bar for flashcard review.
 * Keyboard shortcuts: 1-4
 */
export default function RatingButtons({ onRate, disabled = false }) {
  return (
    <div className="grid grid-cols-4 gap-2.5 w-full">
      {RATINGS.map((r) => (
        <button
          key={r.value}
          onClick={() => !disabled && onRate(r.value)}
          disabled={disabled}
          className={`rating-btn bg-gradient-to-b ${r.gradient} ${r.hoverGradient}
            text-white rounded-xl py-4 px-2 transition-all duration-150
            disabled:opacity-40 disabled:cursor-not-allowed
            active:scale-95 flex flex-col items-center`}
          style={{ boxShadow: disabled ? 'none' : `0 4px 15px ${r.glow}` }}
        >
          <span className="font-bold text-sm">{r.label}</span>
          <span className="text-xs opacity-75 mt-0.5">{r.sublabel}</span>
          <span className="text-[10px] opacity-40 mt-1.5 font-mono">{r.key}</span>
        </button>
      ))}
    </div>
  );
}
